import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import { WEBSITE_PAGE_TYPES as PAGE_TYPES } from 'components/manage/website/util/pageTypes';

import WebsitePreview from './WebsitePreview';

const mapStateToProps = state => {
  const page = state.website.pages.byId[state.website.pages.activePage.id];
  const pageType = page && page.type;
  const weddingInfoFormSelector = formValueSelector('weddingInfoForm');
  const isHome = page && page.type === PAGE_TYPES.HOME;
  const showStickyPreview = isHome || (page && page.type === PAGE_TYPES.EVENT);
  const { date, wedding = {}, account = {} } = weddingInfoFormSelector(
    state,
    'date',
    'hashtag',
    'wedding',
    'account'
  );

  return {
    isHome,
    values: state.website.websitePreview,
    activePage: page,
    pages: state.website.pages.orderedIds.map(id => state.website.pages.byId[id]),
    wedding: state.wedding.wedding,
    weddingValues: isHome
      ? {
          date,
          hashtag: wedding.hashtag,
          title: wedding.title,
          city: account.city,
          stateProvince: account.state_province,
        }
      : null,
    account: state.wedding.account,
    pageComponentKey: pageType,
    showStickyPreview,
  };
};

const WebsitePreviewContainer = connect(mapStateToProps)(WebsitePreview);

export default WebsitePreviewContainer;
